var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#EDEAFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9759 41.9667C40.0443 40.7332 38.8389 39.7328 37.4548 39.0445C36.0708 38.3562 34.5457 37.9986 32.9999 38C31.4541 37.9986 29.9291 38.3562 28.545 39.0445C27.1609 39.7328 25.9556 40.7332 25.0239 41.9667M40.9759 41.9667C42.7939 40.3496 44.0761 38.2181 44.6548 35.8548C45.2336 33.4915 45.0803 31.0081 44.2152 28.734C43.3502 26.4598 41.8142 24.5024 39.8111 23.1212C37.808 21.74 35.4324 21.0004 32.9993 21.0004C30.5662 21.0004 28.1905 21.74 26.1874 23.1212C24.1843 24.5024 22.6484 26.4598 21.7833 28.734C20.9183 31.0081 20.7649 33.4915 21.3437 35.8548C21.9225 38.2181 23.2059 40.3496 25.0239 41.9667M40.9759 41.9667C38.7813 43.9243 35.9408 45.0042 32.9999 45C30.0586 45.0045 27.2189 43.9246 25.0239 41.9667M36.9999 30C36.9999 31.0609 36.5785 32.0783 35.8284 32.8284C35.0782 33.5786 34.0608 34 32.9999 34C31.9391 34 30.9217 33.5786 30.1715 32.8284C29.4214 32.0783 28.9999 31.0609 28.9999 30C28.9999 28.9391 29.4214 27.9217 30.1715 27.1716C30.9217 26.4214 31.9391 26 32.9999 26C34.0608 26 35.0782 26.4214 35.8284 27.1716C36.5785 27.9217 36.9999 28.9391 36.9999 30Z",
    stroke: "#5E4DE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.75082ac4af8af05b37492bab80946019.svg";
export { ForwardRef as ReactComponent };